import React from "react";
import styles from "./StatusMessage.module.css";

export default function StatusMessage({
  message,
  variant,
  children,
  className = "",
}) {
  const content = children ?? message;

  if (!content) return null;

  let resolvedVariant = variant;

  if (!resolvedVariant && typeof content === "string") {
    if (content.startsWith("✅")) resolvedVariant = "success";
    else if (content.startsWith("❌")) resolvedVariant = "error";
    else resolvedVariant = "info";
  }

  const variantClass =
    resolvedVariant === "success"
      ? styles.success
      : resolvedVariant === "error"
      ? styles.error
      : styles.info;

  return (
    <div className={`${styles.alert} ${variantClass} ${className}`.trim()}>
      {content}
    </div>
  );
}